export default __webpack_public_path__ + "static/media/pricing-packages-bg.78262868.jpg";